import { call, put, takeLatest } from "redux-saga/effects";
import { PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../services/axios";
import { API_ENDPOINTS } from "../../constants/api";
import {
  fetchFolders,
  fetchFoldersSuccess,
  fetchFoldersFailure,
} from "../reducers/qmsFolderStructureSlice";
import { notify } from "../../utils/notification";

function* fetchFoldersSaga(
  action: PayloadAction<{
    elementId: string;
    parentFolderId?: string;
    folderType?: string;
    status?: string;
  }>,
): Generator<any, void, any> {
  try {
    const { elementId, parentFolderId, folderType, status } = action.payload;

    if (folderType === undefined && parentFolderId === undefined) {
      const response = yield call(
        axiosInstance.get,
        `${API_ENDPOINTS.ELEMENT.ELEMENTS}/${elementId}/folders`,
        {
          params: {
            page: 1,
            limit: 10,
            parentFolderId: parentFolderId || null,
          },
        },
      );

      const { items, meta } = response.data.data;
      // Only filter out level 0 folders, allow Documents folders
      const filteredFolders = items.filter((folder: any) => folder.level >= 0);

      yield put(
        fetchFoldersSuccess({
          folders: filteredFolders,
          meta,
          parentFolderId: parentFolderId || null,
        }),
      );
    } else if (folderType && folderType == "STANDARD") {
      const response = yield call(
        axiosInstance.get,
        `${API_ENDPOINTS.ELEMENT.ELEMENTS}/${elementId}/folders`,
        {
          params: {
            page: 1,
            limit: 10,
            parentFolderId: parentFolderId || null,
          },
        },
      );

      const { items, meta } = response.data.data;
      // Only filter out level 0 folders, allow Documents folders
      const filteredFolders = items.filter((folder: any) => folder.level >= 0);

      yield put(
        fetchFoldersSuccess({
          folders: filteredFolders,
          meta,
          parentFolderId: parentFolderId || null,
        }),
      );
    } else if (folderType && folderType === "DOCUMENTS" && parentFolderId) {
      const response = yield call(
        axiosInstance.get,
        `${API_ENDPOINTS.FOLDERS.GET_DOCUMENT_TYPE_FOLDER(parentFolderId)}`,
        {
          params: {
            page: 1,
            limit: 10,
          },
        },
      );

      const { items, meta } = response.data.data;
      // Only filter out level 0 folders, allow Documents folders
      const filteredFolders = items;

      yield put(
        fetchFoldersSuccess({
          folders: filteredFolders,
          meta,
          parentFolderId: parentFolderId || null,
        }),
      );
    } else if (folderType && folderType === "RECORDS" && parentFolderId) {
      const params: any = {
        page: 1,
        limit: 10,
      };

      // Add status filter if provided
      if (status) {
        params.status = status;
      } else {
        params.status = null;
      }

      const response = yield call(
        axiosInstance.get,
        `${API_ENDPOINTS.FOLDERS.GET_RECORDS_FOLDER(parentFolderId)}`,
        {
          params,
        },
      );

      const { items, meta } = response.data.data;
      const filteredFolders = items;

      yield put(
        fetchFoldersSuccess({
          folders: filteredFolders,
          meta,
          parentFolderId: parentFolderId || null,
        }),
      );
    } else if (parentFolderId) {
      const response = yield call(
        axiosInstance.get,
        `${API_ENDPOINTS.DOCUMENTS.GET_FOLDERS_DOCUMENT(parentFolderId)}`,
        {
          params: {
            page: 1,
            limit: 10,
          },
        },
      );

      const { items, meta } = response.data.data;
      // Only filter out level 0 folders, allow Documents folders
      const filteredFolders = items;

      yield put(
        fetchFoldersSuccess({
          folders: filteredFolders,
          meta,
          parentFolderId: parentFolderId || null,
        }),
      );
    }
  } catch (error: any) {
    yield put(fetchFoldersFailure(error.message));
    notify.error({
      message: "Error",
      description: error.response?.data?.message || "Failed to fetch folders",
    });
  }
}

// Placeholder for future template fetching
// function* fetchTemplatesSaga(action: PayloadAction<string>): Generator<any, void, any> {
//   try {
//     // TODO: Implement template fetching logic when API is ready
//   } catch (error: any) {
//     // Handle error
//   }
// }

export function* qmsFolderStructureSaga() {
  yield takeLatest(fetchFolders.type, fetchFoldersSaga);
  // yield takeLatest('fetchTemplates', fetchTemplatesSaga); // For future use
}
